/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExchangeRateResponseApiResponse } from '../../models/exchange-rate-response-api-response';

export interface GetLatestExchangeRateQuery$Params {
  Base?: string;
  Target?: string;
}

export function getLatestExchangeRateQuery(http: HttpClient, rootUrl: string, params?: GetLatestExchangeRateQuery$Params, context?: HttpContext): Observable<StrictHttpResponse<ExchangeRateResponseApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getLatestExchangeRateQuery.PATH, 'get');
  if (params) {
    rb.query('Base', params.Base, {});
    rb.query('Target', params.Target, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExchangeRateResponseApiResponse>;
    })
  );
}

getLatestExchangeRateQuery.PATH = '/api/rates/latest';
